import { render } from "./settle-apply.vue?vue&type=template&id=4122789e&scoped=true"
import script from "./settle-apply.vue?vue&type=script&lang=js"
export * from "./settle-apply.vue?vue&type=script&lang=js"

import "./settle-apply.vue?vue&type=style&index=0&id=4122789e&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4122789e"]])

export default __exports__